/**
 * ORDEM ALFABÉTICA — a configuração única de "como listar nomes" deste sistema.
 *
 * O padrão é o da agenda do Planejamento: A→Z em português, sem diferenciar
 * maiúscula/minúscula nem acento ("Álvaro" fica junto de "Alvaro", antes de
 * "Bruno"), e com números em ordem natural ("Veículo 2" antes de "Veículo 10").
 *
 * A TELA é a garantia: ordenamos uma CÓPIA no ponto de exibição, sem mexer no
 * array original (que pode estar sendo usado por índice) nem no banco.
 */
export const compararNomes = (a: unknown, b: unknown) =>
  String(a ?? "").localeCompare(String(b ?? ""), "pt-BR", { sensitivity: "base", numeric: true });

/** Devolve uma CÓPIA da lista ordenada de A→Z pelo nome que `nome` extrai de cada item. */
export function ordenarPorNome<T>(lista: readonly T[], nome: (item: T) => unknown): T[] {
  return [...lista].sort((a, b) => compararNomes(nome(a), nome(b)));
}
